import { render, staticRenderFns } from "./selectGrop.vue?vue&type=template&id=679b6c92&scoped=true"
import script from "./selectGrop.vue?vue&type=script&lang=js"
export * from "./selectGrop.vue?vue&type=script&lang=js"
import style0 from "./selectGrop.vue?vue&type=style&index=0&id=679b6c92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679b6c92",
  null
  
)

export default component.exports